<template>
  <div class='animated fadeIn'>
    <b-row class='justify-content-md-center'>
      <b-col cols='12' lg='10'>
        <b-card class='shadow-sm bg-white rounded' border-variant='light'>
          <div>
            <el-button type='success' icon='el-icon-back' circle @click='goBack'></el-button>
          </div>
        </b-card>
        <b-card class='shadow-sm bg-white rounded' border-variant='light' header-bg-variant='secondary'>
          <b-list-group flush>
            <b-list-group-item>
              <b-row class='justify-content-md-center'>
                <b-col sm='2'>
                  <b-img v-if='service.icon' :src='service.icon' width='128' height='128' rounded></b-img>
                  <b-img v-else border-variant='light' width='128' height='128' rounded></b-img>
                </b-col>
                  <b-col sm='7'>
                    <croppa
                      v-model='myCroppa'
                      :width='256'
                      :height='256'
                      :auto-sizing='true'
                      placeholder='アイコン画像選択'
                      :placeholder-font-size='14'
                      :accept="'image/*'"></croppa>
                  </b-col>
                <b-col sm='2'>
                  <b-button v-if='service.key' class='submit-btn' variant='danger' v-b-modal.modal-center>更新</b-button>
                  <b-button v-else class='submit-btn' variant='danger' v-b-modal.modal-center>登録</b-button>
                  <b-modal v-if='service.key' id='modal-center'
                          ref='modal'
                          title='サービス'
                          @ok='storeData'
                          centered
                          header-bg-variant='danger'
                          body-text-variant='danger'
                          ok-variant='danger'
                          size='sm'
                          class='px100-btn'
                        >
                    <p class='my-4'>サービスを更新します</p>
                    <p class='my-4'>よろしいですか?</p>
                  </b-modal>
                  <b-modal v-else id='modal-center'
                          ref='modal'
                          title='サービス'
                          @ok='storeData'
                          centered
                          header-bg-variant='danger'
                          body-text-variant='danger'
                          ok-variant='danger'
                          size='sm'
                          class='px100-btn'
                        >
                    <p class='my-4'>サービスを登録します</p>
                    <p class='my-4'>よろしいですか?</p>
                  </b-modal>
                </b-col>
              </b-row>
            </b-list-group-item>
            <b-list-group-item>
              <b-card-body>
                <b-row>
                  <b-col sm='3'><label for='input-none'>{{getTitle('name')}}:</label></b-col>
                  <b-col sm='9'><el-input size='medium' type='text' v-model='service.name'></el-input></b-col>
                </b-row>
                <b-row>
                  <b-col sm='3'><label for='input-none'>{{getTitle('subTitle')}}:</label></b-col>
                  <b-col sm='9'><el-input size='medium' type='text' v-model='service.subTitle'></el-input></b-col>
                </b-row>
                <b-row>
                  <b-col sm='3'><label for='input-none'>{{getTitle('entryCode')}}:</label></b-col>
                  <b-col sm='9'>
                    <b-input-group>
                    <el-input size='medium' type='text' v-model='service.entryCode'></el-input>
                    <b-input-group-append>
                      <b-btn variant="outline-primary" v-on:click="generateEntryCode()"><i class="fas fa-key"></i></b-btn>
                      </b-input-group-append>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm='4'><label for='input-none'>{{getTitle('tosLink')}}:</label></b-col>
                  <b-col sm='8'><el-input size='medium' type='url' v-model='service.tosLink'></el-input></b-col>
                </b-row>
                <b-row>
                  <b-col sm='4'><label for='input-none'>{{getTitle('ppLink')}}:</label></b-col>
                  <b-col sm='8'><el-input size='medium' type='url' v-model='service.ppLink'></el-input></b-col>
                </b-row>
                <b-row>
                  <b-col sm='4'><label for='input-none'>{{getTitle('company')}}:</label></b-col>
                  <b-col sm='8'><el-input size='medium' type='url' v-model='service.company'></el-input></b-col>
                </b-row>
                <b-row>
                  <b-col sm='4'><label for='input-none'>{{getTitle('position')}}:</label></b-col>
                  <b-col sm='8'><el-input size='medium' type='url' v-model='service.position'></el-input></b-col>
                </b-row>
                <b-row>
                  <b-col sm='4'><label for='input-none'>{{getTitle('representative')}}:</label></b-col>
                  <b-col sm='8'><el-input size='medium' type='url' v-model='service.representative'></el-input></b-col>
                </b-row>
                <b-row>
                  <b-col sm='4'><label for='input-none'>{{getTitle('option')}}:</label></b-col>
                  <b-col sm='8'>
                    <b-list-group>
                      <b-list-group-item class='d-flex justify-content-between align-items-center'>
                        名前
                        <b-form-checkbox id='checkbox0' v-model="service.option['name']"></b-form-checkbox>
                      </b-list-group-item>
                      <b-list-group-item class='d-flex justify-content-between align-items-center'>
                        生年月日
                        <b-form-checkbox id='checkbox1' v-model="service.option['dateOfBirth']"></b-form-checkbox>
                      </b-list-group-item>
                      <b-list-group-item class='d-flex justify-content-between align-items-center'>
                        所属
                        <b-form-checkbox id='checkbox2' v-model="service.option['organization']"></b-form-checkbox>
                      </b-list-group-item>
                    </b-list-group>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-list-group-item>
            <b-list-group-item>
              <b-card-body>
                <b-row>
                  <b-col sm='4'><label for='input-none'>{{getTitle('groups')}}:</label></b-col>
                  <b-col sm='2'></b-col>
                </b-row>
                <b-row>
                  <b-col sm='2'></b-col>
                  <b-col sm='10'>
                   <b-table
                      :items='groups'
                      :fields='fields'>
                      <div slot='icon' class='avatar' slot-scope='item'>
                        <b-img v-if='item.value' :src='item.value' width='32' height='32'></b-img>
                        <!-- <b-img v-else src='../admin.png' width='32' height='32' class='img-avatar'></b-img> -->
                      </div>
                      <div slot='name' slot-scope='item'>
                        <p>{{ item.value }}</p>
                      </div>
                      <div slot='key' slot-scope='item'>
                        <b-form-checkbox :id='item.value' v-model='selectedGroup[item.value]' @change='changeGroup()'></b-form-checkbox>
                      </div>
                    </b-table>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-list-group-item>
            <b-list-group-item>
              <b-card-body>
                <b-row>
                <b-col sm='4'><label for='input-none'>{{getTitle('users')}}:</label></b-col>
                <b-col sm='2'></b-col>
                </b-row>
                <b-row>
                  <b-col sm='2'></b-col>
                  <b-col sm='10'>
                    <b-table
                      :items='myUsers'
                      :fields='fieldsUsers'
                      :current-page='currentPage'
                      :per-page='perPage'>
                      <div slot='icon' class='avatar' slot-scope='item'>
                        <b-img v-if='item.value' :src='item.value' width='32' height='32'></b-img>
                        <!-- <b-img v-else src='../admin.png' width='32' height='32' class='img-avatar'></b-img> -->
                      </div>
                      <div slot='name' slot-scope='item'>
                        <p>{{ item.value }}</p>
                      </div>
                      <div slot='key' slot-scope='item'>
                        <b-form-checkbox :id='item.value' v-model='selectedUser[item.value]' @change='changeUser()'></b-form-checkbox>
                      </div>
                    </b-table>
                  <b-pagination align='center' size='sm' :total-rows='myUsers.length' v-model='currentPage' :per-page='perPage'>
                  </b-pagination>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-list-group-item>
            <b-list-group-item>
              <b-card-body>
                <b-row>
                  <b-col sm='4'><label for='input-none'>{{getTitle('enable')}}:</label></b-col>
                  <b-col>
                    <b-form-checkbox id='checkbox3' v-model='service.enable'></b-form-checkbox>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm='4'><label for='input-none'>{{getTitle('updatedAt')}}:</label></b-col>
                  <b-col>{{ service.updatedAt * 1000 | moment }}</b-col>
                </b-row>
                <b-row>
                  <b-col sm='4'><label for='input-none'>{{getTitle('createdAt')}}:</label></b-col>
                  <b-col>{{ service.createdAt * 1000 | moment }}</b-col>
                </b-row>
                <b-row>
                  <b-col sm='4'><label for='input-none'>{{getTitle('owner')}}:</label></b-col>
                  <b-col>
                    <b-img v-if='getUserIcon(service)' :src='getUserIcon(service)' width='32' height='32' class='img-avatar'></b-img>
                    <!-- <b-img v-else src='../admin.png' width='32' height='32' class='img-avatar'></b-img> -->
                  </b-col>
                </b-row>
              </b-card-body>
            </b-list-group-item>
            <b-list-group-item v-if='service.key != null'>
              <b-card-body>
                <b-row>
                  <b-col sm='3'><label for='input-none'>ルーティンリファレンス:</label></b-col>
                  <b-col sm='9'>
                    <el-transfer
                      :titles="['未選択', '選択中']"
                      target-order='unshift'
                      filterable
                      :filter-method='filterMethod'
                      filter-placeholder='Keyword'
                      v-model='routineSelected'
                      :data='routineList'>
                    </el-transfer>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-list-group-item>
            <b-list-group-item v-if='service.key != null'>
              <b-card-body>
                <b-row>
                  <b-col sm='3'><label for='input-none'>データ出力:</label></b-col>
                  <b-col sm='9'>
                    <span>開始（指定日以上）</span>
                    <div class='block'>
                      <el-date-picker
                        v-model="startDate"
                        type='date'
                        placeholder='Pick a day'
                        value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </div>
                    <span>終了（指定日未満）</span>
                    <div class='block'>
                      <el-date-picker
                        v-model="endDate"
                        type='date'
                        placeholder='Pick a day'
                        value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </div>
                    <br>
                    <b-button class='submit-btn' variant='danger' v-b-modal.modal-export>Export</b-button>
                    <b-modal id='modal-export'
                          ref='modal-export'
                          title='データ出力'
                          @ok='exportData'
                          centered
                          header-bg-variant='danger'
                          body-text-variant='danger'
                          ok-variant='danger'
                          size='sm'
                          class='px100-btn'
                        >
                      <p class='my-4'>ユーザデータを出力します。</p>
                      <p class='my-4'>よろしいですか?</p>
                    </b-modal>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-list-group-item>
          </b-list-group>
        </b-card>
        <b-modal ref='errorModal' centered title='Error' class='text-danger' :ok-only='true' ok-variant=danger header-bg-variant=danger>
          <p class='my-4'>{{errorMessage}}</p>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/storage'
import moment from 'moment'
import { mapGetters } from 'vuex'
import * as Papa from 'papaparse'
export default {
  data () {
    return {
      routineList: [],
      routineSelected: [],
      fields: {
        icon: {
          label: '',
          class: 'text-center'
        },
        name: {
          label: '名称',
          class: 'text-center'
        },
        key: {
          label: '',
          class: 'text-center'
        }
      },
      fieldsUsers: {
        icon: {
          label: '',
          class: 'text-center'
        },
        name: {
          label: '名称',
          class: 'text-center'
        },
        email: {
          label: 'Email',
          class: 'text-center',
          sortable: true
        },
        key: {
          label: '',
          class: 'text-center'
        }
      },
      currentPage: 1,
      perPage: 10,
      myCroppa: {},
      errorMessage: '',
      file: null,
      uploadedImage: null,
      titles: {
        'owner': '作成',
        'entryCode': 'エントリーコード',
        'name': '名称',
        'groups': '登録グループ',
        'users': '登録ユーザ',
        'subTitle': '説明',
        'tosLink': '利用規約（URL）',
        'ppLink': 'プライバシーポリシー（URL）',
        'icon': 'Icon',
        'company': '団体名（登録者）',
        'position': '役職（登録者）',
        'representative': '役割（登録者）',
        'routine': 'Routine',
        'chats_ref': 'Chats room reference',
        'enable': '有効',
        'option': 'オプション',
        'updatedAt': '更新日時',
        'createdAt': '作成日時'
      },
      service: null,
      serviceSave: null,
      unwatch: null,
      unsubscribe: null,
      myUsers: [],
      selectedGroup: {},
      selectedUser: {},
      isChangeGroup: false,
      isChangeUser: false,
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      membersData: {},
      membersRoutine: {}
    }
  },
  beforeDestroy () {
    if (this.unwatch) {
      this.unwatch()
    }
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  },
  created () {
    this.unwatch = this.$store.watch(state => this.$store.getters['service/services'], value => {
      this.init()
    })
    this.init()
  },
  methods: {
    changeUser () {
      this.isChangeUser = true
    },
    changeGroup () {
      this.isChangeGroup = true
    },
    usersLen () {
      return Object.keys(this.service.users).length
    },
    init () {
      const index = this.services.findIndex(service => service.key === this.parameter)
      if (index !== -1) {
        this.service = JSON.parse(JSON.stringify(this.services[index]))
      } else {
        this.service = {
          'key': null,
          'owner': this.user.key,
          'entryCode': '',
          'groups': {},
          'users': {},
          'name': '',
          'subTitle': '',
          'tosLink': location.protocol + '//' + location.host + '/Terms',
          'ppLink': location.protocol + '//' + location.host + '/Privacy',
          'icon': '',
          'company': '',
          'position': '',
          'representative': '',
          'routine': [],
          'chats_ref': '',
          'enable': true,
          'option': {
            'name': true,
            'dateOfBirth': true,
            'organization': true
          },
          'createdAt': parseInt(new Date().getTime() / 1000),
          'updatedAt': parseInt(new Date().getTime() / 1000)
        }
      }
      this.getMyUsers()
      var keys = Object.keys(this.service.groups)
      for (var i in keys) {
        if (this.service.groups[keys[i]]) {
          this.selectedGroup[keys[i]] = this.service.groups[keys[i]]
        }
      }
      keys = Object.keys(this.service.users)
      for (i in keys) {
        if (this.service.users[keys[i]]) {
          this.selectedUser[keys[i]] = this.service.users[keys[i]]
        }
      }
      this.serviceSave = JSON.parse(JSON.stringify(this.service))
      this.getRoutineBelongs()
    },
    generateEntryCode () {
      while (true) {
        var entryCode = Math.floor(Math.random() * 1000000).toString()
        var index = this.services.findIndex(service => service.entryCode === entryCode)
        if (index === -1) {
          this.service.entryCode = entryCode
          break
        }
      }
    },
    filterMethod (query, item) {
      return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
    },
    showModal () {
      this.$refs.errorModal.show()
    },
    hideModal () {
      this.$refs.errorModal.hide()
    },
    generateImage: function () {
      let url = this.myCroppa.generateDataUrl()
      if (!url) {
        this.errorMessage = 'No image selected'
        this.showModal()
      }
    },
    goBack () {
      this.$router.go(-1)
    },
    img_src () {
      return this.service.icon
    },
    getItem (item) {
      return this.service[item]
    },
    getTitle (item) {
      return this.titles[item]
    },
    onFileSelected (event) {
      this.file = event.target.files[0]
      this.createImage(this.file)
    },
    getUserIcon (service) {
      const index = this.users.findIndex(user => user.key === service.owner)
      if (index !== -1) {
        return this.users[index].icon
      }
      return null
    },
    createImage (file) {
      let reader = new FileReader()
      reader.onload = (e) => {
        this.service.icon = e.target.result
      }
      reader.readAsDataURL(file)
    },
    generateUuid () {
      let chars = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.split('')
      for (let i = 0, len = chars.length; i < len; i++) {
        switch (chars[i]) {
          case 'x':
            chars[i] = Math.floor(Math.random() * 16).toString(16)
            break
          case 'y':
            chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16)
            break
        }
      }
      return chars.join('')
    },
    getMyUsers () {
      this.myUsers = []
      for (var index in this.users) {
        var user = this.users[index]
        if (user.services[this.service.key] || this.user.role === 'admin') {
          this.myUsers.push(user)
        }
      }
    },
    writeService () {
      var vm = this
      var before = JSON.parse(JSON.stringify(this.serviceSave))
      var tempG = {}
      var tempU = {}
      var keys = Object.keys(this.selectedGroup)
      for (var x in keys) {
        if (this.selectedGroup[keys[x]]) {
          tempG[keys[x]] = true
        }
      }
      keys = Object.keys(this.selectedUser)
      for (x in keys) {
        if (this.selectedUser[keys[x]]) {
          tempU[keys[x]] = true
        }
      }
      const payload = {
        'owner': this.service.owner,
        'entryCode': this.service.entryCode,
        'groups': tempG,
        'users': tempU,
        'name': this.service.name,
        'subTitle': this.service.subTitle,
        'tosLink': this.service.tosLink,
        'ppLink': this.service.ppLink,
        'icon': this.service.icon,
        'company': this.service.company,
        'position': this.service.position,
        'representative': this.service.representative,
        'routine': this.service.routine,
        'chats_ref': this.service.chats_ref,
        'enable': this.service.enable,
        'option': this.service.option,
        'createdAt': this.service.createdAt,
        'updatedAt': parseInt(new Date().getTime() / 1000)
      }
      var routineRef = []
      for (var i = 0; i < this.routineSelected.length; i++) {
        var routine = this.routineList[this.routineSelected[i]]
        routineRef.push(routine.initial)
      }
      payload.routine = routineRef
      const db = firebase.firestore()
      const settings = { timestampsInSnapshots: true }
      db.settings(settings)
      const batch = db.batch()
      var refService = null
      if (this.service.key) {
        refService = db.collection('services').doc(this.service.key)
      } else {
        refService = db.collection('services').doc()
      }

      if (!this.service.key) {
        var refChats = db.collection('chats').doc()
        batch.set(refChats, { 'unread': {}, 'read': {}, 'last': null, 'createdAt': parseInt(new Date().getTime() / 1000) })

        var refChatsRefs = db.collection('chats_refs').doc(refService.id)
        batch.set(refChatsRefs, {'chats_ref': refChats.id, 'createdAt': parseInt(new Date().getTime() / 1000)})

        payload.chats_ref = refChats.id
        batch.set(refService, payload)

        var refChatsRefFrom = db.collection('chats_refs').doc(refService.id).collection('refs').doc(payload.owner)
        batch.set(refChatsRefFrom,
          {
            'location': refChats.id,
            'type': 'service',
            'status': 'pending',
            'enable': false,
            'createdAt': parseInt(new Date().getTime() / 1000),
            'updatedAt': parseInt(new Date().getTime() / 1000)
          }
        )
        var refChatsRefTo = db.collection('chats_refs').doc(payload.owner).collection('refs').doc(refService.id)
        batch.set(refChatsRefTo,
          {
            'location': refChats.id,
            'type': 'service',
            'status': 'requesting',
            'enable': false,
            'createdAt': parseInt(new Date().getTime() / 1000),
            'updatedAt': parseInt(new Date().getTime() / 1000)
          }
        )
      } else {
        batch.set(refService, payload)
      }

      if (this.isChangeUser) {
        for (var key in payload.users) {
          if (payload.users[key] && !before.users[key]) {
            refChatsRefFrom = db.collection('chats_refs').doc(refService.id).collection('refs').doc(key)
            batch.set(refChatsRefFrom,
              {
                'location': payload.chats_ref,
                'type': 'service',
                'status': 'pending',
                'enable': false,
                'createdAt': parseInt(new Date().getTime() / 1000),
                'updatedAt': parseInt(new Date().getTime() / 1000)
              }
            )
            refChatsRefTo = db.collection('chats_refs').doc(key).collection('refs').doc(refService.id)
            batch.set(refChatsRefTo,
              {
                'location': payload.chats_ref,
                'type': 'service',
                'status': 'requesting',
                'enable': false,
                'createdAt': parseInt(new Date().getTime() / 1000),
                'updatedAt': parseInt(new Date().getTime() / 1000)
              }
            )
          }
        }
        for (key in before.users) {
          if (!payload.users[key] && before.users[key]) {
            refChatsRefFrom = db.collection('chats_refs').doc(refService.id).collection('refs').doc(key)
            batch.delete(refChatsRefFrom)

            refChatsRefTo = db.collection('chats_refs').doc(key).collection('refs').doc(refService.id)
            batch.delete(refChatsRefTo)
          }
        }
      }

      batch.commit().then(function () {
        var async = require('async')
        if (vm.isChangeGroup) {
          vm.isChangeGroup = false
          var groups = JSON.parse(JSON.stringify(vm.groups))
          async.each(groups, function (group, cb) {
            if (vm.checkIfModifiedGroup(payload, group, before)) {
              var refGroup = db.collection('groups').doc(group.key)
              db.runTransaction(function (transaction) {
                return transaction.get(refGroup).then(function (doc) {
                  if (!doc.exists) {
                    throw new Error('Document does not exist!')
                  }
                  var services = doc.data().services
                  if (payload.groups[group.key]) {
                    services[refService.id] = payload.groups[group.key]
                  } else {
                    delete services[refService.id]
                  }
                  transaction.update(refGroup, { services: services })
                  transaction.update(refGroup, { updatedAt: parseInt(new Date().getTime() / 1000) })
                })
              }).then(function () {
                cb()
                // console.log('Transaction successfully committed!')
              }).catch(function (error) {
                cb()
                console.log('Transaction failed: ', error)
              })
            } else {
              cb()
            }
          }, function (err) {
            if (err) console.log(err)
          })
        }
        if (vm.isChangeUser) {
          vm.isChangeUser = false
          var users = JSON.parse(JSON.stringify(vm.users))
          async.each(users, function (user, cb) {
            if (vm.checkIfModifiedUser(payload, user, before)) {
              var refUser = db.collection('users').doc(user.key)
              db.runTransaction(function (transaction) {
                return transaction.get(refUser).then(function (doc) {
                  if (!doc.exists) {
                    throw new Error('Document does not exist!')
                  }
                  var services = doc.data().services
                  if (payload.users[user.key]) {
                    services[refService.id] = payload.users[user.key]
                  } else {
                    delete services[refService.id]
                  }
                  transaction.update(refUser, { services: services })
                  transaction.update(refUser, { updatedAt: parseInt(new Date().getTime() / 1000) })
                })
              }).then(function () {
                cb()
                // console.log('Transaction successfully committed!')
              }).catch(function (error) {
                cb()
                console.log('Transaction failed: ', error)
              })
            } else {
              cb()
            }
          }, function (err) {
            vm.offLoading()
            if (err) console.log(err)
          })
        } else {
          vm.offLoading()
        }
        // vm.$router.go(-1)
      })
    },
    checkIfModifiedUser (payload, user, before) {
      if (payload.users[user.key] !== undefined && !before.users[user.key]) {
        return true
      }
      if (before.users[user.key] !== undefined && !payload.users[user.key]) {
        return true
      }
      return false
    },
    checkIfModifiedGroup (payload, group, before) {
      if (payload.groups[group.key] !== undefined && !before.groups[group.key]) {
        return true
      }
      if (before.groups[group.key] !== undefined && !payload.groups[group.key]) {
        return true
      }
      return false
    },
    storeData () {
      var vm = this
      vm.onSending()
      this.myCroppa.generateBlob((blob) => {
        if (blob) {
          var uuid = this.generateUuid()
          var storageRef = firebase.storage().ref().child('services').child(this.service.owner).child(uuid)
          var uploadTask = storageRef.put(blob)
          uploadTask.on('state_changed', function (snapshot) {
            // var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                break
              case firebase.storage.TaskState.RUNNING: // or 'running'
                break
            }
          }, function (error) {
            vm.offLoading()
            vm.errorMessage = error.errorMessage
            vm.showModal()
          }, function () {
            uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
              vm.service.icon = downloadURL
              vm.myCroppa.remove()
              vm.writeService()
            })
          })
        } else {
          vm.writeService()
        }
      })
    },
    dataExport () {
      var vm = this
      const status = [
        '/',
        '×',
        '◯'
      ]
      return new Promise((resolve, reject) => {
        var aTag = null
        var blob = null
        var temp = []
        const config = {
          delimiter: ',', // 区切り文字
          header: true, // キーをヘッダーとして扱う
          newline: '\n' // 改行
        }
        var keys = Object.keys(vm.membersData)
        for (var i in keys) {
          var index = vm.users.findIndex(u => u.key === keys[i])
          var name = ''
          if (index !== -1) {
            name = vm.users[index].name
            if (name === '' || name === null) {
              name = vm.users[index].email
            }
            var data = vm.membersData[keys[i]]
            for (var x in data) {
              var k = null
              var offset = null
              var rname = ''
              var payload = {}
              for (var y in data[x].routineService) {
                k = Object.keys(data[x].routineService[y])
                for (var z in k) {
                  offset = vm.routines.findIndex(r => r.key === k[z])
                  rname = ''
                  if (offset !== -1) {
                    rname = vm.routines[offset].title
                  }
                  payload = {
                    '名前': '"' + name + '"',
                    'MAIL': vm.users[index].email,
                    '実施日': data[x].dateText,
                    'TYPE': 'S',
                    'KEY': k[z],
                    'ルーティン': '"' + rname + '"',
                    'RESULT': data[x].routineService[y][k[z]],
                    '結果': status[data[x].routineService[y][k[z]]]
                  }
                  temp.push(payload)
                }
              }
              for (y in data[x].routineGroup) {
                k = Object.keys(data[x].routineGroup[y])
                for (z in k) {
                  offset = vm.routines.findIndex(r => r.key === k[z])
                  rname = ''
                  if (offset !== -1) {
                    rname = vm.routines[offset].title
                  }
                  payload = {
                    '名前': '"' + name + '"',
                    'MAIL': vm.users[index].email,
                    '実施日': data[x].dateText,
                    'TYPE': 'G',
                    'KEY': k[z],
                    'ルーティン': '"' + rname + '"',
                    'RESULT': data[x].routineGroup[y][k[z]],
                    '結果': status[data[x].routineGroup[y][k[z]]]
                  }
                  temp.push(payload)
                }
              }
              k = Object.keys(data[x].routineUser)
              for (z in k) {
                offset = vm.routines.findIndex(r => r.key === k[z])
                rname = ''
                if (offset !== -1) {
                  rname = vm.routines[offset].title
                }
                payload = {
                  '名前': '"' + name + '"',
                  'MAIL': vm.users[index].email,
                  '実施日': data[x].dateText,
                  'TYPE': 'U',
                  'KEY': k[z],
                  'ルーティン': '"' + rname + '"',
                  'RESULT': data[x].routineUser[k[z]],
                  '結果': status[data[x].routineUser[k[z]]]
                }
                temp.push(payload)
              }
              k = Object.keys(data[x].routineSelf)
              for (z in k) {
                var rself = vm.membersRoutine[vm.users[index].key][k[z]]
                payload = {
                  '名前': '"' + name + '"',
                  'MAIL': vm.users[index].email,
                  '実施日': data[x].dateText,
                  'TYPE': 'M',
                  'KEY': k[z],
                  'ルーティン': rself.share ? '"' + rself.title + '"' : '"(非公開)"',
                  'RESULT': data[x].routineSelf[k[z]],
                  '結果': status[data[x].routineSelf[k[z]]]
                }
                temp.push(payload)
              }
            }
          }
        }
        const delimiterString = Papa.unparse(temp, config)
        blob = new Blob([delimiterString], { type: 'text/csv;' })
        aTag = document.createElement('a')
        aTag.download = moment().format('YYYY-MM-DD') + '-' + vm.startDate + '-' + vm.endDate + '.csv'
        if (window.navigator.msSaveBlob) {
          // for IE
          window.navigator.msSaveBlob(blob, aTag.download)
        } else if (window.URL && window.URL.createObjectURL) {
          // for Firefox
          aTag.href = window.URL.createObjectURL(blob)
          document.body.appendChild(aTag)
          aTag.click()
          document.body.removeChild(aTag)
        } else if (window.webkitURL && window.webkitURL.createObject) {
          // for Chrome
          aTag.href = (window.URL || window.webkitURL).createObjectURL(blob)
          aTag.click()
        } else {
          // for Safari
          window.open(
            `data:type/csv;base64,${window.Base64.encode(this.state.content)}`,
            '_blank'
          )
        }
        resolve()
      })
    },
    getMembersRoutineSelf () {
      var vm = this
      vm.membersRoutine = {}
      var async = require('async')
      return new Promise((resolve, reject) => {
        const db = firebase.firestore()
        const settings = { timestampsInSnapshots: true }
        db.settings(settings)
        async.each(vm.users, function (user, cb) {
          if (user.services[vm.service.key]) {
            var dbRef = db.collection('routine_self').doc(user.key).collection('data')
            dbRef.get().then(function (querySnapshot) {
              querySnapshot.forEach(function (doc) {
                if (typeof vm.membersRoutine[doc.ref.parent.parent.id] === 'undefined') {
                  vm.membersRoutine[doc.ref.parent.parent.id] = {}
                }
                vm.membersRoutine[doc.ref.parent.parent.id][doc.id] = doc.data()
              })
              cb()
            }).catch(function (error) {
              console.log('Error getting cached document:', error)
              cb()
            })
          } else {
            cb()
          }
        }, function (err) {
          if (err) console.log(err)
          resolve()
        })
      })
    },
    getMembersRoutineData () {
      var vm = this
      vm.membersData = {}
      var async = require('async')
      return new Promise((resolve, reject) => {
        const db = firebase.firestore()
        const settings = { timestampsInSnapshots: true }
        db.settings(settings)
        async.each(vm.users, function (user, cb) {
          if (user.services[vm.service.key]) {
            var dbRef = db.collection('routine_data').doc(user.key).collection('data')
            dbRef
              .where('date', '>=', parseInt(new Date(vm.startDate + ' 00:00:00').getTime() / 1000))
              .where('date', '<=', parseInt(new Date(vm.endDate + ' 00:00:00').getTime() / 1000))
              .get().then(function (querySnapshot) {
                querySnapshot.forEach(function (doc) {
                  if (typeof vm.membersData[doc.ref.parent.parent.id] === 'undefined') {
                    vm.membersData[doc.ref.parent.parent.id] = []
                  }
                  vm.membersData[doc.ref.parent.parent.id].push(doc.data())
                })
                cb()
              }).catch(function (error) {
                console.log('Error getting cached document:', error)
                cb()
              })
          } else {
            cb()
          }
        }, function (err) {
          if (err) console.log(err)
          resolve()
        })
      })
    },
    exportData () {
      var vm = this
      vm.onSending()
      const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
      pause(1000).then(() => {
        vm.getMembersRoutineData().then(function () {
          vm.getMembersRoutineSelf().then(function () {
            vm.dataExport().then(function () {
              vm.offLoading()
            })
          })
        })
      })
    },
    getRoutineBelongs () {
      var vm = this
      vm.routineList = []
      vm.routineSelected = []
      Object.keys(vm.routineRefs).forEach(function (key, index) {
        vm.routineList.push({
          label: this[key].title,
          key: index,
          initial: this[key].key
        })
        if (vm.routinesBelong !== null) {
          for (var i = 0; i < vm.service.routine.length; i++) {
            if (vm.service.routine[i].indexOf(this[key].key) >= 0) {
              vm.routineSelected.push(index)
            }
          }
        }
      }, vm.routineRefs)
    }
  },
  computed: {
    ...mapGetters({
      routines: 'routine/routines',
      routineGroups: 'routineGroup/routineGroups',
      routineRefs: 'routineRef/routineRefs',
      routineSelf: 'routineSelf/routineSelf',
      routineData: 'routineData/routineData',
      services: 'service/services',
      groups: 'group/groups',
      users: 'user/users',
      user: 'authUser/user',
      parameter: 'dispatch/service'
    })
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY/MM/DD HH:mm')
    },
    momentShort: function (date) {
      return moment(date).format('YYYY/MM/DD')
    },
    momentMMDD: function (date) {
      return moment(date).format('MM/DD')
    }
  }
}
</script>

<style>
.textTitle {
  white-space: normal;
}
.img {
  max-width: 100%;
  height: auto;
}
.row {
  padding-bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/Service.vue